var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "productQualityTests.measurementSpecificationTemplate.model.name"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.template.name,
              expression: "template.name"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", disabled: !_vm.editable },
          domProps: { value: _vm.template.name },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.template, "name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("PqtMeasurementSpecifications", {
        attrs: {
          container: _vm.template,
          editable: _vm.editable,
          inheritMedia: false
        }
      }),
      _vm._v(" "),
      _c("MeasurementSpecificationTemplateMedias", {
        attrs: { template: _vm.template, editable: _vm.editable }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }